import { __decorate } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import noop from 'lodash/noop';
import Slider from 'choerodon-ui/lib/slider';
import { NumberField } from '../number-field/NumberField';
let Range = class Range extends NumberField {
    renderWrapper() {
        return (React.createElement("label", Object.assign({ key: "wrapper" }, this.getWrapperProps()), this.renderTrack()));
    }
    renderTrack() {
        const { props: { dataSet, onChange = noop, ...otherProps }, prefixCls, } = this;
        if (dataSet) {
            const { fields = [] } = dataSet.props;
            let props = {};
            if (otherProps.name) {
                const fieldProps = fields.find(x => x.name === otherProps.name);
                props = fieldProps;
            }
            return (React.createElement(Slider, Object.assign({ prefixCls: prefixCls }, otherProps, props, { onChange: (value) => {
                    this.setValue(value);
                    onChange(value);
                } })));
        }
        return (React.createElement(Slider, Object.assign({ prefixCls: prefixCls }, otherProps, { onChange: onChange })));
    }
};
Range.displayName = 'Range';
Range.propTypes = {
    /**
     * 是否垂直方向
     * @default
     * false
     */
    vertical: PropTypes.bool,
    dots: PropTypes.bool,
    marks: PropTypes.object,
    included: PropTypes.bool,
    ...NumberField.propTypes,
};
Range.defaultProps = {
    ...NumberField.defaultProps,
    suffixCls: 'range',
    min: 0,
    step: 1,
    max: 100,
    vertical: false,
    dots: false,
    marks: {},
    included: true,
    range: false,
    tipFormatter: null,
};
Range = __decorate([
    observer
], Range);
export default Range;
